/**
 * Web Push (PWA) — subscribe após login quando SW + VAPID disponíveis.
 */

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function getVapidPublicKey(api) {
  const { data } = await api.get('/core/push/vapid-public-key/');
  return data;
}

export async function subscribeWebPush(api) {
  if (typeof window === 'undefined') return { ok: false, reason: 'ssr' };
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return { ok: false, reason: 'unsupported' };
  }
  if (!window.isSecureContext) {
    return { ok: false, reason: 'insecure' };
  }

  const vapid = await getVapidPublicKey(api);
  if (!vapid?.configured || !vapid.publicKey) {
    return { ok: false, reason: 'not_configured' };
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    return { ok: false, reason: 'denied' };
  }

  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapid.publicKey),
    });
  }

  const json = subscription.toJSON();
  await api.post('/core/push/subscribe/', {
    endpoint: json.endpoint,
    keys: json.keys,
  });
  return { ok: true };
}

export async function unsubscribeWebPush(api) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    await api.patch('/core/push/preferencia/', { aceita_web_push: false });
    return;
  }
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      const endpoint = subscription.endpoint;
      await subscription.unsubscribe();
      await api.post('/core/push/unsubscribe/', { endpoint });
    }
  } catch {
    /* ignore */
  }
  await api.patch('/core/push/preferencia/', { aceita_web_push: false });
}

/** Tenta ativar push em background (não bloqueia UX). */
export function tryEnableWebPush(api) {
  if (typeof window === 'undefined') return;
  // Só faz sentido com SW registrado (produção) e em contexto seguro
  if (process.env.NODE_ENV !== 'production') return;
  if (!('Notification' in window)) return;

  // Evita pedir permissão agressivamente no desktop; PWA/mobile primeiro
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const standalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;
  if (!isMobile && !standalone) return;

  // Se já negou, não insiste
  if (Notification.permission === 'denied') return;

  subscribeWebPush(api).catch((err) => {
    console.warn('Web Push não ativado:', err);
  });
}
